import { render, staticRenderFns } from "./VxResourceSet.vue?vue&type=template&id=5099ec00&scoped=true"
import script from "./VxResourceSet.vue?vue&type=script&lang=js"
export * from "./VxResourceSet.vue?vue&type=script&lang=js"
import style0 from "./VxResourceSet.vue?vue&type=style&index=0&id=5099ec00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099ec00",
  null
  
)

export default component.exports